// TopoMapCore.js
// Dünne Außen-Fassade des Karten-Moduls (= window.ModuleJS.TopoMap). Hält keine eigene
// Map-/Layout-Logik mehr, sondern delegiert an:
//   - MapController  (Verhalten/Zustand: Bootstrap, Marker, Kreissuche, Listener, Events, switchTo)
//   - ViewController (Layout/DOM: Float, Canvas-Wechsel, Controls)

import { ViewController } from "./controller/ViewController.js";
import { MapController } from "./controller/MapController.js";

export class TopoMapCore {
    viewController;
    mapController;
    #bootstrapConfig;

    constructor({mapAdapter, markerFactory, markerClustererLib}) {
        this.viewController = new ViewController({
            isMainActive: () => this.isMainActive(),
            isGalleryActive: () => this.isGalleryActive(),
            performMapAction: (action, opts) => this.mapController.mapAdapter.performMapAction(action, opts),
            getMapInstance: () => this.mapController.getMapInstance(),
            getCurrentCanvas: () => this.mapController.getCurrentCanvas(),
            scheduleTimeout: (name, delay, cb) => this.mapController.scheduleTimeout(name, delay, cb)
        });

        this.mapController = new MapController({
            mapAdapter,
            markerFactory,
            markerClustererLib,
            viewController: this.viewController
        });
    }

    // --- Bootstrap / Events (Delegation an MapController) ---
    registerEvents() { this.mapController.registerEvents(); }
    setOpenGalleryHandler(callback) { this.mapController.setOpenGalleryHandler(callback); }
    initializeLegacyBridges(bridges) {
        this.mapController.initializeLegacyBridges(bridges);
        this.viewController.setConnectors(bridges);
    }
    initialize(canvasId, mapOptions = {}, mode = 'main') { this.mapController.initialize(canvasId, mapOptions, mode); }
    start(config) { return this.mapController.start(config); }

    // --- Bootstrap-Bridge (Phase 2f): Config früh sammeln (createTopoMap), Map lazy starten ---
    configure(config) { this.#bootstrapConfig = { ...config }; }
    bootstrap(initGallery = false) {
        const c = this.#bootstrapConfig;
        return this.start({
            canvasId: 'map_canvas',
            mapOptions: c.mapOptions,
            layoutConnector: c.layoutConnector,
            globalObjectConnector: c.globalObjectConnector,
            openGallery: c.openGallery,
            initGallery
        });
    }
    setMapOptions(mode = 'main', customOpts = {}) { this.mapController.setMapOptions(mode, customOpts); }
    setMapListeners() { this.mapController.setMapListeners(); }

    // --- Queries / Marker / Overlay (Delegation an MapController) ---
    getMapInstance() { return this.mapController.getMapInstance(); }
    getCurrentCanvas() { return this.mapController.getCurrentCanvas(); }
    hasValidMap() { return this.mapController.hasValidMap(); }
    isMainActive() { return this.mapController.isMainActive(); }
    isGalleryActive() { return this.mapController.isGalleryActive(); }
    isMain() { return this.mapController.isMain(); }
    isGallery() { return this.mapController.isGallery(); }
    triggerResize() { this.mapController.triggerResize(); }
    fitBounds(bounds) { this.mapController.fitBounds(bounds); }
    switchToGallery() { this.mapController.switchToGallery(); }
    restoreMain() { this.mapController.restoreMain(); }
    switchTo(to, localRes) { this.mapController.switchTo(to, localRes); }

    addDocumentMarkers(dataArray) { this.mapController.addDocumentMarkers(dataArray); }
    clearDocumentMarkers() { this.mapController.clearDocumentMarkers(); }
    highlightDocumentMarker(id, active = true) { this.mapController.highlightDocumentMarker(id, active); }
    addArchiveMarkers(dataArray) { this.mapController.addArchiveMarkers(dataArray); }
    clearArchiveMarkers() { this.mapController.clearArchiveMarkers(); }
    highlightArchiveMarker(id, active = true) { this.mapController.highlightArchiveMarker(id, active); }
    scheduleTimeout(name, delay, callback) { this.mapController.scheduleTimeout(name, delay, callback); }
    fitToAllMainMapMarkers() { this.mapController.fitToAllMainMapMarkers(); }
    getAllDocumentMarkers() { return this.mapController.getAllDocumentMarkers(); }
    addGalleryMarkers({ locations, viewpoints, mapoptions }) { this.mapController.addGalleryMarkers({ locations, viewpoints, mapoptions }); }
    deleteGalleryMarkers() { this.mapController.deleteGalleryMarkers(); }
    fitToGalleryMapMarkers(index = null) { this.mapController.fitToGalleryMapMarkers(index); }
    createOverlay() { return this.mapController.createOverlay(); }
    removeOverlay() { this.mapController.removeOverlay(); }
    listenOverlayReady(callback) { this.mapController.listenOverlayReady(callback); }
    deleteCircle() { this.mapController.deleteCircle(); }
    clearMarkers(mode) { this.mapController.clearMarkers(mode); }

    // --- View (Delegation an ViewController) ---
    updateFloat() { this.viewController.updateFloat(); }
    addArchiveToggleControl(opts = {}) { return this.viewController.createArchiveToggle(opts); }
}
